/* Start Section nwkw_category_page_hero_banner_with_bloks_Cekznw */
document.addEventListener("DOMContentLoaded",function(){const videoPlayers=document.querySelectorAll("video-player");videoPlayers.forEach((player,index)=>{const video=player.querySelector("video");const transcript=player.querySelector(".video-transcript");if(video&&transcript){let transcriptId=transcript.id;if(!transcriptId){transcriptId=`video-transcript-${index + 1}`;transcript.id=transcriptId;}
video.setAttribute("aria-describedby",transcriptId);const altText=video.getAttribute("alt")||video.getAttribute("aria-label")||"Video with transcript available.";video.setAttribute("aria-label",altText);video.setAttribute("alt",altText);if(!video.hasAttribute("tabindex")){video.setAttribute("tabindex","0");}}});});
/* End Section nwkw_category_page_hero_banner_with_bloks_Cekznw */
/* Start Section nwkw_category_page_video_wLQGJb */
document.addEventListener('DOMContentLoaded',function(){const thumbnails=document.querySelectorAll('.video-thumbnail');thumbnails.forEach(thumb=>{thumb.addEventListener('click',function(){const videoUrl=thumb.dataset.videoUrl+'?autoplay=1';const iframe=document.createElement('iframe');iframe.setAttribute('src',videoUrl);iframe.setAttribute('frameborder','0');iframe.setAttribute('allowfullscreen','');iframe.setAttribute('allow','autoplay');iframe.classList.add('responsive-iframe');const wrapper=thumb.closest('.video-wrapper');const videoFrame=wrapper.querySelector('.video-frame');videoFrame.innerHTML='';videoFrame.appendChild(iframe);videoFrame.style.display='block';thumb.style.display='none';});});});
/* End Section nwkw_category_page_video_wLQGJb */
/* Start Section nwkw_category_page_featured_collection_b7mHKP */
function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--nwkw_category_page_featured_collection_b7mHKP .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section nwkw_category_page_featured_collection_b7mHKP */
/* Start Section nwkw_category_page_featured_collection_KbLpiT */
function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--nwkw_category_page_featured_collection_KbLpiT .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section nwkw_category_page_featured_collection_KbLpiT */
/* Start Section nwkw_category_page_featured_collection_pRT7B6 */
function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--nwkw_category_page_featured_collection_pRT7B6 .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section nwkw_category_page_featured_collection_pRT7B6 */
/* Start Section nwkw_category_page_featured_collection_jpbrUt */
function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--nwkw_category_page_featured_collection_jpbrUt .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section nwkw_category_page_featured_collection_jpbrUt */
/* Start Section nwkw_category_page_featured_collection_8VDdAW */
function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--nwkw_category_page_featured_collection_8VDdAW .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section nwkw_category_page_featured_collection_8VDdAW */
/* Start Section nwkw_category_page_featured_collection_iFqDMr */
function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--nwkw_category_page_featured_collection_iFqDMr .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section nwkw_category_page_featured_collection_iFqDMr */
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
(function () {
  // Check if the custom element is already defined
  if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
      constructor() {
        super();
        this.videos = this.querySelectorAll('video');
        this.videoWeb = this.videos[0];
        this.videoMob = this.videos[1];
        this.playBtn = this.querySelector('.play-btn');
        this.soundBtn = this.querySelector('.mute-btn');
        this.disableClick = this.dataset.click;

        if (this.disableClick) {
          this.initEventListeners();
        }
      }

      initEventListeners() {
        this.videos.forEach(video => {
          video.addEventListener('click', () => this.togglePlay(video));
          video.addEventListener('ended', () => this.handleVideoEnded(video));
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', () => this.handlePlayButton());
        }

        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', () => this.toggleMute());
        }

        window.addEventListener('resize', () => this.handleResize());
      }

      togglePlay(video) {
        if (video.paused) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      }

      playVideo(video) {
        this.videos.forEach(otherVideo => {
          if (otherVideo !== video) {
            otherVideo.pause();
            otherVideo.muted = true;
          }
        });

        video.muted = false;
        video.play();
        this.classList.add('played');

        // ✅ Hide the Play button
        if (this.playBtn) {
          this.playBtn.style.opacity = '0';
          this.playBtn.style.pointerEvents = 'none'; // Prevent clicking while hidden
        }

        if (this.soundBtn) {
          this.soundBtn.classList.remove('active');
        }
      }

      pauseVideo(video) {
        video.pause();
        video.muted = true;
        this.classList.remove('played');

        // ✅ Show the Play button again
        if (this.playBtn) {
          this.playBtn.style.opacity = '1';
          this.playBtn.style.pointerEvents = 'auto';
        }

        if (this.soundBtn) {
          this.soundBtn.classList.add('active');
        }
      }
      pauseAllVideo() {
        this.videos.forEach(video => {
          this.pauseVideo(video)
        });
      }

      handlePlayButton() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) this.togglePlay(targetVideo);
      }

      toggleMute() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) {
          targetVideo.muted = !targetVideo.muted;
          this.soundBtn.classList.toggle('active', targetVideo.muted);
        }
      }

      handleResize() {
        if (!this.videoMob) return;

        const isMobile = window.innerWidth < 749;
        const targetVideo = isMobile ? this.videoMob : this.videoWeb;

        this.videos.forEach(video => {
          video.pause();
          video.muted = true;
        });

        targetVideo.play();
        targetVideo.muted = false;
        targetVideo.pause();
      }

      handleVideoEnded(video) {
        if (!video.loop) {
          this.classList.remove('played');
          video.muted = true;

          // ✅ Show the Play button again
          if (this.playBtn) {
            this.playBtn.style.opacity = '1';
            this.playBtn.style.pointerEvents = 'auto';
          }
        }
      }
    }

    // Define the custom element
    customElements.define('video-player', VideoPlayer);
  }
})();
if (!customElements.get('carousel-slider')) {
  class CarouselSlider extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.has_pre_injected_media = false;
    }

    connectedCallback() {
      this.init();
      
      // If a selected media is pre-injected, set that in has_pre_injected_media.
      // In that case, in gotoSlide, we will use index + 1.
      const selectedMediaEl = this.mainMedia.querySelector('[data-wwai-selected-variant-product-media]');
      if (selectedMediaEl) {
        this.has_pre_injected_media = true;
      }
    }

    init() {
      this.cacheElements();
      this.bindEvents();
      // We dont perform scroll here, since either we have 
      // pre injected media or we will use index = 0 or we will call gotoSlide from 
      // functionality generator.
      // this.scrollToMediaItem(this.activeIndex);
    }

    cacheElements() {
      this.mainMedia = this.querySelector('main-slider');
      this.thumbSlider = this.querySelector('thumb-slider');
      this.thumbVertical = this.thumbSlider?.dataset.vartical;
      this.pagenation = this.querySelector('pagenation');
      this.mediaItems = this.mainMedia?.querySelectorAll('main-slider-slide') || [];
      this.thumbItems = this.thumbSlider?.querySelectorAll('thumb-slider-slide') || [];
      this.pageItems = this.pagenation?.querySelectorAll('button.page-media-item') || [];
    }

    bindEvents() {
      const mediaBtnNext = this.querySelector('.media-next');
      const mediaBtnPrev = this.querySelector('.media-prev');

      mediaBtnNext?.addEventListener('click', () => this.goToNext());
      mediaBtnPrev?.addEventListener('click', () => this.goToPrev());

      // Only add thumbnail event listeners if thumbItems exist
      if (this.thumbItems && this.thumbItems.length > 0) {
        this.thumbItems.forEach((thumb, index) => {
          thumb.addEventListener('click', () => this.scrollToMediaItem(index));
        });
      }
    
      this.pageItems.forEach((page, index) => {
        page.addEventListener('click', () => this.scrollToMediaItem(index));
      });
    
      let scrollTimeout = null;
      this.mainMedia?.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => this.handleScrollSnap(), 200);
      });
    
      const updateThumbSliderHeight = () => {
        if (this.thumbSlider && this.thumbVertical && window.innerWidth > 768) {
          this.thumbSlider.style.maxHeight = this.mainMedia.offsetHeight + 'px';
        } else if (this.thumbSlider) {
          this.thumbSlider.style.maxHeight = '';
        }
      };
      
      setTimeout(updateThumbSliderHeight, 200);
      
      window.addEventListener('resize', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateThumbSliderHeight, 200);
      });
    }

    handleScrollSnap() {
      const scrollLeft = this.mainMedia.scrollLeft;
      const itemWidth = this.mediaItems[0]?.clientWidth || 0;
      const offset = scrollLeft + this.mainMedia.offsetLeft;

      let closestIndex = 0;
      let minDiff = Infinity;
      this.mediaItems.forEach((item, i) => {
        const diff = Math.abs(item.offsetLeft - offset);
        if (diff < minDiff) {
          minDiff = diff;
          closestIndex = i;
        }
      });

      this.scrollToMediaItem(closestIndex);
    }

    goToNext() {
      if (this.activeIndex < this.mediaItems.length - 1) {
        this.scrollToMediaItem(this.activeIndex + 1);
      }
    }

    goToPrev() {
      if (this.activeIndex > 0) {
        this.scrollToMediaItem(this.activeIndex - 1);
      }
    }

    scrollToMediaItem(index) {
      if (!this.mediaItems.length) return;
    
      this.mediaItems[this.activeIndex]?.classList.remove('active');
      this.thumbItems[this.activeIndex]?.classList.remove('active');
      this.pageItems[this.activeIndex]?.classList.remove('active');
      
      const video_player = this.mediaItems[this.activeIndex].querySelector('video-player');
      
      this.activeIndex = index;
      
      if (video_player) {
        video_player.pauseAllVideo();
      }
    
      this.mediaItems[this.activeIndex]?.classList.add('active');
      this.thumbItems[this.activeIndex]?.classList.add('active');
      this.pageItems[this.activeIndex]?.classList.add('active');
    
      const scrollLeft = this.mediaItems[this.activeIndex].offsetLeft - this.mainMedia.offsetLeft;
      this.mainMedia.scrollTo({ left: scrollLeft, behavior: 'smooth' });

      try {
          if (this.thumbSlider && this.thumbVertical && window.innerWidth > 768) {
            const thumbScroll = this.thumbItems[this.activeIndex].offsetTop - this.thumbSlider.offsetTop - ((this.thumbSlider.clientHeight / 2) - (this.thumbItems[this.activeIndex].clientHeight / 2));
            this.thumbSlider.scrollTo({ top: thumbScroll, behavior: 'smooth' });  
          } else {
            const thumbScroll = this.thumbItems[this.activeIndex].offsetLeft - this.thumbSlider.offsetLeft - ((this.thumbSlider.clientWidth / 2) - (this.thumbItems[this.activeIndex].clientWidth / 2));
            this.thumbSlider.scrollTo({ left: thumbScroll, behavior: 'smooth' });  
          }
        } catch (error) {
          console.log('error in thumb scroll', error);
        }
    }

    refresh(index = 0) {
      this.activeIndex = index;
      this.cacheElements();
      this.bindEvents();
    }

    createCustomCarouselSlide(data, isThumbnail = false) {
      const slideTag = isThumbnail ? 'thumb-slider-slide' : 'main-slider-slide';
      const slideClass = isThumbnail ? 'thumb-media-item' : 'main-media-item';
      const slide = document.createElement(slideTag);
      slide.className = slideClass;
      slide.id = isThumbnail ? undefined : `wwai-media-${data.id}`;
  
      const img = document.createElement('img');
      img.src = isThumbnail ? `${data.src}&width=${data.width}` : data.src;
      img.alt = data.alt || "Image";
      img.width = data.width;
      img.height = data.height;
      img.loading = 'lazy';
      img.className = isThumbnail ? 'thumb-media-img' : 'main-media-img';
  
      const srcset = isThumbnail
        ? `${data.src}&width=${data.width} ${data.width}w`
        : [
            `${data.src}&width=352 352w`,
            `${data.src}&width=832 832w`,
            `${data.src}&width=1200 1200w`,
            `${data.src}&width=1920 1920w`,
            `${data.src}&width=2561 2561w`
          ].join(', ');
  
      img.setAttribute('srcset', srcset);
      img.setAttribute('sizes', '(min-width: 1536px) 1500px,(min-width: 1280px) 1250px,(min-width: 768px) 994px,(min-width: 768px) 708px,(min-width: 640px) 610px,100vw');
  
      if (isThumbnail) {
        slide.setAttribute('data-handle', `media-${data.id}`);
        slide.setAttribute('data-img-id', data.src);
      }
  
      slide.appendChild(img);
      return slide;
    }

    gotoSlide(index) {
      console.log('isReinitializing4', index);
      if (!this.mediaItems.length) return;

      // We need to make sure that we use custom media config in functionality.
      // we can improve this by making clear slide not delete the pre injected media.
      let index_to_use = index;
      if (this.has_pre_injected_media) {
        index_to_use = index + 1;
      }

      if (index_to_use < 0) {
        const resolvedIndex = this.mediaItems.length + index;
        this.scrollToMediaItem(resolvedIndex);
      } else {
        this.scrollToMediaItem(index_to_use);
      }
    }

    clearSlides() {
      this.mainMedia.innerHTML = '';
      if (this.thumbSlider) {
        this.thumbSlider.innerHTML = '';
      }
      this.mediaItems = [];
      this.thumbItems = [];
      this.activeIndex = 0;
    }
  }
  
  customElements.define('carousel-slider', CarouselSlider);
}
